export default function changeAxisOpacity(sel, x, scale, spanPickerType = 'depth') {
    sel.style('opacity', function (datum: Date | number) {
        return Math.min(
            ...[x].map(xx => {
                if (!xx) return 1
                const value: number = spanPickerType == 'time' ? datum.getTime() : datum
                const distance = Math.abs(scale(value) - xx)
                if (distance > 50) {
                    return 1
                } else {
                    return distance / 50
                }
            })
        )
    })
}
